import { createFileRoute } from "@tanstack/react-router";

import { AdminEngagement } from "@/features/admin";

/**
 * Admin Engagement — wire path ``/admin/engagement``.
 *
 * Mounted under ``_authed/_modal`` so the future full-screen modal chrome
 * (Stream 1) wraps the page. Until then the stub forwards via ``<Outlet />``
 * and this renders inside the regular authed shell.
 *
 * v1 reference: ``app/admin-v2/components/pages/EngagementPage.tsx`` (415 LoC).
 */
export const Route = createFileRoute("/_authed/_modal/admin/engagement")({
  component: AdminEngagement,
});
